'use client';

import { Entry } from '@/lib/parsers/entries';
import { useView } from '@/lib/store/hooks';
import { fmtCategoryNames } from '@/lib/utils/format';
import { PageHeaderProps } from '.';
import ShareArticle from '../ShareArticle';
import Box, { BoxProps } from '../ui/Box';
import Divider from '../ui/Divider';
import Flex from '../ui/Flex';
import Txt from '../ui/Txt';
import PageProfiles from './PageProfiles';

type PageMetaProps = BoxProps<'div'> & Partial<PageHeaderProps>;

export default function PageMeta({ children, ...props }: PageMetaProps) {
  const page = useView() as Entry<'article'>;
  const articleDate = page?.postDate;
  const articleCategory = fmtCategoryNames(page?.contentTypeCategorySingle);

  return (
    <Box cx={{ mT: 'md' }} {...props}>
      <Flex direction="row" alignItems="center" columnGap="3xs">
        <Txt as="span" variant="body">
          {children || articleCategory}
        </Txt>
        <Divider direction="vertical" />
        <Txt as="span" variant="body">
          {articleDate}
        </Txt>
      </Flex>
      <PageProfiles {...page} />
      <Box cx={{ pT: '2xs' }}>
        <ShareArticle />
      </Box>
    </Box>
  );
}
